import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PROGRESS_FEATURE_KEY } from './keys';
import { progressReducer } from './reducers/progress.reducer';
import { ProgressEffects } from './effects/progress.effects';
import { ProgressNextEffects } from './bridge';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(PROGRESS_FEATURE_KEY, progressReducer), EffectsModule.forFeature(ProgressEffects, ProgressNextEffects)],
})
export class ProgressStoreModule {}
